import React from 'react';
import * as css from 'styles/form/toggle.scss';

export function Toggle(props) {
  return (
    <div onClick={() => props.onChange(!props.value)} className={`${css.container} ${props.disabled && css.disabled}`}>
      <div className={css.track}>
        <div className={`${css.toggle} ${props.value && css.on}`} />
      </div>
      <div className={`${css.label} ${props.value && css.on}`}>
        { props.label }
      </div>
    </div>
  );
}
